import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { axiosPost } from "../../utils/AxiosApi";
import { URL } from "../../utils/Constants";
import { ReactMultiEmail } from "react-multi-email";
import makeAnimated from "react-select/animated";
import "react-multi-email/style.css";
import CreatableSelect from 'react-select/creatable';

import { emailValidate } from "../../utils/Utils";

const components = {
  DropdownIndicator: null,
};

const animatedComponents = makeAnimated();

const MailConfiguration = () => {
  const [sendToOptions, setSendToOptions] = useState([]);
  const [sendTo, setSendTo] = useState([]);
  const [sendCcto, setSendCcto] = useState([]);
  const [ccToOptions, setCcToOptions] = useState([]);
  const [sendToConfig, setSendToConfig] = useState([
    {
      sendTo: "",
    },
  ]);
  const [ccToConfig, setCcToConfig] = useState([
    {
      ccTo: "",
    },
  ]);

  const [sendToValue, setSendToValue] = useState([]);
  const [ccToValue, setCcToValue] = useState([]);

  const addSendTo = (e) => {
    e.preventDefault();
    let mailConfiguration = [...sendToConfig];
    mailConfiguration.push({
      sendTo: "",
    });
    setSendToConfig(mailConfiguration);
  };

  const handleDeleteSendTo = (param) => {
    axiosPost(URL.deleteEmailConfiguration, param, (response) => {
      if (response.status === 200) {
      }
    });
  };

  const removeSendTo = (e, id) => {
    e.preventDefault();
    let mailConfiguration = [...sendToConfig];
    mailConfiguration.splice(id, 1);
    if (mailConfiguration.length < 1) {
      swal({ title: "Oops", text: "Atleast one question is necessary" });
    } else {
      setSendToConfig(mailConfiguration);
    }

    const param = {
      id: "",
      isCC: false,
    };
    handleDeleteSendTo(param);
  };

  const addCCto = (e) => {
    e.preventDefault();
    let mailConfiguration = [...ccToConfig];
    mailConfiguration.push({
      sendTo: "",
    });
    setCcToConfig(mailConfiguration);
  };

  const removeCCTo = (e, id) => {
    e.preventDefault();
    let mailConfiguration = [...ccToConfig];
    mailConfiguration.splice(id, 1);
    if (mailConfiguration.length < 1) {
      swal({ title: "Oops", text: "Atleast one question is necessary" });
    } else {
      setCcToConfig(mailConfiguration);
    }
  };

  // const getAllEmailConfiguration = () => {
  //   axiosPost(URL.getEmailConfiguration, "", (response) => {
  //     if (response.status === 200) {
  //       setSendTo([]);
  //       const SendToOptions = response?.data?.data?.sendToValues?.map(
  //         (item) => item.email
  //       );
  //       const CcToOptions = response?.data?.data?.sendCcValues?.map(
  //         (item) => item.email
  //       );
  //       setSendTo(SendToOptions);
  //       setSendCcto(CcToOptions);
  //     }
  //   });
  // };

  const getAllEmailConfiguration = () => {
    axiosPost(URL.getEmailConfiguration, "", (response) => {
      if (response.status === 200) {
        setSendTo([]);
        const SendToOptions = response?.data?.data?.sendToValues?.map(
          (item) => ({ value: item.id, label: item.email })
        );
        const CcToOptions = response?.data?.data?.sendCcValues?.map(
          (item) => ({ value: item.id, label: item.email })
        );
        setSendTo(SendToOptions);
        setSendCcto(CcToOptions);
      }
    });
  };

  // const handleEmailSend = () => {
  //   const params = {
  //     sendTos: sendTo,
  //     sendCcs: sendCcto,
  //   };

  //   if (sendTo.length > 0) {
  //     axiosPost(URL.insertEmailConfiguration, params, (response) => {
  //       if (response.status === 200) {
  //         swal({ title: "Success", text: "Email saved Successfully" });
  //         getAllEmailConfiguration();
  //       }
  //     });
  //   } else {
  //     swal("Oops", "One primary email is required");
  //   }
  // };

  // const handleEmailSend = () => {
  //   const params = {
  //     sendTos: sendTo.map((option) => option.label),
  //     sendCcs: sendCcto.map((option) => option.label),
  //   };
  //   if (sendTo.length > 0) {
  //     axiosPost(URL.insertEmailConfiguration, params, (response) => {
  //       if (response.status === 200) {
  //         swal({ title: "Success", text: "Email saved Successfully" });
  //         getAllEmailConfiguration();
  //       }
  //     });
  //   } else {
  //     swal("Oops", "One primary email is required");
  //   }
  // };
  const validateEmails = (params) => {
    let emailCheck = true;
    const invalidEmails = [];
    params.sendTos && params.sendTos.forEach((email) => {
      if (!emailValidate(email)) {
        emailCheck = false;
        invalidEmails.push(email);
      }
    });
    params.sendCcs && params.sendCcs.forEach((email) => {
      if (!emailValidate(email)) {
        emailCheck = false;
        invalidEmails.push(email);
      }
    });

    if (invalidEmails.length === 1) {
      // invalidEmails.forEach((email) => {
      //   swal("Warning", `${email} is invalid`, "");
      // });
      // const invalidEmailList = invalidEmails.join(", ");
      const invalidEmailList = invalidEmails.map(email => `<div>${email}</div>`).join('');
      // swal("Warning", `This email is invalid: ${invalidEmailList}`, "");
      swal({
        title: "Warning",
        content: {
          element: "div",
          attributes: {
            innerHTML: `Following email is invalid:<br>${invalidEmailList}`,
          },
        },
      });
    }
    if (invalidEmails.length > 1) {
      const invalidEmailList = invalidEmails.map(email => `<div>${email}</div>`).join('');
      swal({
        title: "Warning",
        content: {
          element: "div",
          attributes: {
            innerHTML: `Following emails are invalid:<br>${invalidEmailList}`,
          },
        },
      });

    }
    return emailCheck;
  };

  const handleEmailSend = () => {
    const params = {
      sendTos: sendTo?.length > 0 ? sendTo.map((option) => option.label) : [],
      sendCcs: sendCcto?.length > 0 ? sendCcto.map((option) => option.label) : [],
    };
    if (sendTo.length > 0) {
      const emailCheck = validateEmails(params);
      if (emailCheck) {
        axiosPost(URL.insertEmailConfiguration, params, (response) => {
          if (response.status === 200) {
            swal({ title: "Success", text: "Email saved Successfully" });
            getAllEmailConfiguration();
          }
        });
      }
    } else {
      swal("Oops", "One primary email is required");
    }
  };
  useEffect(() => {
    getAllEmailConfiguration();
  }, []);

  return (
    <div className="tt-widgetContent-tab-holder" style={{ height: "79.5vh" }}>
      <div className="tt-group-header">
        <div className="row mt-2">
          <div className="col-md-6">
            <label for="sendTo">Send To</label>
            <CreatableSelect
              className="form-control h-auto"
              components={components}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  textShadow: 'none !important',
                }),
              }}
              isMulti
              placeholder="Send To"
              value={sendTo?.map((email) => ({ value: email?.value, label: email?.label }))}
              onChange={(options) => {
                setSendTo(options?.map((option) => ({ value: option.value, label: option.label })));
              }}
            />
            {/* <ReactMultiEmail
              placeholder="Send To"
              emails={sendTo}
              onChange={(_emails) => {
                setSendTo(_emails);
              }}
              getLabel={(email, index, removeEmail) => {
                return (
                  <div data-tag key={index}>
                    <div data-tag-item>{email}</div>
                    <span data-tag-handle onClick={() => removeEmail(index)}>
                      ×
                    </span>
                  </div>
                );
              }}
            /> */}
          </div>
          <div className="col-md-6">
            <label for="sendCCTo">CCs To</label>
            {/* <ReactMultiEmail
              placeholder="Send CC to"
              emails={sendCcto}
              onChange={(_emails) => {
                setSendCcto(_emails);
              }}
              getLabel={(email, index, removeEmail) => {
                return (
                  <div data-tag key={index}>
                    <div data-tag-item>{email}</div>
                    <span data-tag-handle onClick={() => removeEmail(index)}>
                      ×
                    </span>
                  </div>
                );
              }}
            /> */}

            <CreatableSelect
              className="form-control h-auto"
              components={components}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  textShadow: 'none !important',
                }),
              }}
              isMulti
              placeholder="CCs To"
              value={sendCcto?.map((email) => ({ value: email?.value, label: email?.label }))}
              onChange={(options) => {
                setSendCcto(options?.map((option) => ({ value: option.value, label: option.label })));
              }}
            />

          </div>
        </div>
        {(sendTo?.length > 0) && (
          <div className="d-flex justify-content-right mt-2">
            <button
              className="tt-button tt-button-primary"
              onClick={(e) => handleEmailSend(e)}
            >
              Save Configuration
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default MailConfiguration;
